import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
	selector: 'app-idle-modal',
	templateUrl: './idle-modal.component.html',
	styleUrls: ['./idle-modal.component.css']
})
export class IdleModalComponent implements OnInit, OnDestroy {

	// Count down for idling before leave
	public countdown: number;
	// Countdown inerval
	private countdownInterval;
	constructor(
		public dialogRef: MatDialogRef<IdleModalComponent>
	) { }

	close(result: 'leave' | 'stay') {
		switch (result) {
			case 'leave':
				this.dialogRef.close('leave');
				break;
			case 'stay':
				this.dialogRef.close('stay');
		}
	}
	startCountdown() {
		if (this.countdownInterval) {
			clearInterval(this.countdownInterval);
		}
		this.countdownInterval = setInterval(() => {
			if (this.countdown > 0) {
				this.countdown--;
			} else {
				this.close('leave');
			}
		}, 1000);
	}
	ngOnInit() {
		this.countdown = 30;
		this.startCountdown();
	}
	ngOnDestroy() {
		if (this.countdownInterval) {
			clearInterval(this.countdownInterval);
		}
	}

}
